// rootReducer.js
import { combineReducers } from 'redux';
import apiReducer from './apiSlice';
// import userReducer from './userSlice';

const rootReducer = combineReducers({
  api: apiReducer,
//   user: userReducer,
  // Add more reducers as needed
});

export default rootReducer;
